import React, { useState } from "react";

import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import { importArticle } from "./api/marketing";
import { getErrorMessage } from "./api/generic";

const styles = {
  closeButton: {
    position: "absolute",
    top: "0",
    right: "0",
    "&:hover": {
      cursor: "pointer",
      color: "#F50057",
    },
  },
};

const ARTICLE_TYPES = [
  "blog",
  "cheat-sheet",
  "guide",
  "tutorial",
  "newsletter",
];

function MarketingImportModal(props) {
  const [type, setType] = useState("blog");
  const [slug, setSlug] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const doImport = () => {
    if (!slug.trim()) {
      setError("Please enter a slug.");
      return;
    }
    setLoading(true);
    setError("");
    importArticle(
      type,
      slug.trim(),
      () => {
        setLoading(false);
        setSlug("");
        props.importedCallback();
      },
      (error) => {
        setLoading(false);
        setError(getErrorMessage(error));
      }
    );
  };

  return (
    <Dialog
      onClose={() => props.closeModal(false)}
      open={props.open}
      maxWidth={"sm"}
      fullWidth
    >
      <IconButton
        sx={styles.closeButton}
        onClick={() => props.closeModal(false)}
      >
        <CloseIcon />
      </IconButton>
      <DialogTitle>Import Article</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" mb={2}>
          Looks the article up by type + slug in stage first, then production,
          and registers it here so it can be edited - the markdown itself is
          left as-is.
        </Typography>
        <FormControl size="small" fullWidth>
          {error !== "" && (
            <Box p={1}>
              <Alert severity="error">{error}</Alert>
            </Box>
          )}

          <FormControl margin="dense" fullWidth>
            <InputLabel id="marketing-import-type-label">Type</InputLabel>
            <Select
              labelId="marketing-import-type-label"
              label="Type"
              value={type}
              onChange={(event) => setType(event.target.value)}
            >
              {ARTICLE_TYPES.map((articleType) => (
                <MenuItem key={articleType} value={articleType}>
                  {articleType}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl margin="dense" fullWidth>
            <TextField
              label="Slug"
              placeholder="web-scraping-python"
              value={slug}
              onChange={(event) => setSlug(event.target.value)}
            />
          </FormControl>

          <Button
            color="primary"
            variant="contained"
            disabled={loading}
            onClick={doImport}
            className="dq-mt-5"
          >
            {loading ? <CircularProgress size={24} /> : "Import"}
          </Button>
        </FormControl>
      </DialogContent>
    </Dialog>
  );
}

export default MarketingImportModal;
